import {AdrService} from '@nuskin/ns-shop';
import {CartService} from '@nuskin/ns-shop';

/**
 *
 * CartServices
 *
 * @namespace CartServices
 */
const CartServices = {
    /**
   * Convert cartProducts into Array of line items.
   * @memberof CartServices
   * @example
   * CartServices.convertToLineItems(cartProducts)
   * @param {cartProducts}: Products in shop-cart localstorage
   *
   * @return one-time cart products into array of line items
   */
    convertToLineItems (cartProducts) {
        if (cartProducts === null || cartProducts.length === 0) {
            return [];
        }

        let lineItems = [];
        for (let i = 0; i < cartProducts.length; i++) {
            let product = cartProducts[i];
            let item = {
                'lineItem': {
                    'SKU': product.product.sku,
                    'RequestedQuantity': product.qty,
                    'PromoCode': '',
                    'PayWithPoints': false,
                    'OneTime': false,
                    'Action': 'ADD',
                    'Category': null,
                    'Custom': null,
                    'Pricing': null
                },
                'ReplacedSKU': '',
                'Name': product.product.title,
                'AvailableQuantity': product.qty,
                'TotalAvailableQuantity': null,
                'Price': product.price,
                'Points': product.points,
                'FreightPromoSavings': 0,
                'ProductPromoSavings': 0,
                'Tax': 0,
                'TaxBase': 0,
                'PSV': product.pv,
                'CV': product.cv,
                'Freight': 0,
                'BackorderAvailableDate': null,
                'BackOrdered': false,
                'InvalidSku': false,
                'GrandFatheredPricing': false,
                'AddedBySystem': false
            };
            lineItems.push(item);
        }
        return lineItems;
    },
    /**
   * Save products in the cart in localstorage, and clear one-time shopping cart.
   * @memberof CartServices
   * @example
   * CartServices.saveProductsAndClearOneTimeShoppingCart(adrNumber, items)
   */
    saveProductsAndClearOneTimeShoppingCart: (adrNumber, items) => {
    // Save ADR products
        AdrService.editAdrItems(adrNumber, items).then((response) => {
            // Clear shop-cart in localStorage if saving is successful
            if (response.status === 200) {
                localStorage.setItem('adrDetailResponse', JSON.stringify(response.AdrResponse));
                if (CartService.getItemData().length > 0) {
                    CartService.clearCart();
                    return true;
                }
            }
        });
    },
    /**
   * Set shopCartLineItems object in localStorage.
   * @memberof CartServices
   * @example
   * CartServices.setShopCartLineItemsInLocalStorage(shopCartLineItems)
   * @param {shopCartLineItems} shop-cart products in the format of array of line items
   */
    setShopCartLineItemsInLocalStorage: (shopCartLineItems) => localStorage.setItem('shopCartLineItems', JSON.stringify(shopCartLineItems)),
    /**
   * Set ADP cart load mode.
   * @memberof CartServices
   * @example
   * CartServices.setAdpCartLoadMode(mode)
   * @param {mode}: ADP cart load mode.
   *   0 - default, load from LineItemDetails in ADRDetail only
   *   1 - load from LineItemDetails in ADRDetail and shopCartLineItems in localStorage
   *   2 - load from shopCartLineItems in localStorage only
   */
    setAdpCartLoadMode: (mode) => localStorage.setItem('adpCartLoadMode', mode)
};

export default CartServices;
